import { FC } from 'react'
import cls from '../styles/StaticContent.module.scss'
import { HeaderBar } from '@/components/HeaderBar'
import { GetServerSideProps } from 'next'
import { SEO } from '@/components/SEO'
import Link from 'next/link'
import { Footer } from '@/components/Footer'

interface SSP {
  insideTeams: boolean
}

import { articles } from '@/utils/articleData';

const ArticlesIndex: FC<SSP> = ({ insideTeams }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <SEO
        title="Delayed Send - Articles and Guides"
        description="Explore our collection of articles, tutorials, and guides about scheduling messages in Microsoft Teams, productivity tips, and best practices for team communication."
        keywords="Microsoft Teams articles, Teams productivity, Delayed Send guides, scheduling messages tutorials"
      />
      <HeaderBar showLogOutButton={false} className={insideTeams ? '!hidden' : ''} />
      <div className={`${cls.container} flex-grow`}>
        <h1>Delayed Send - Articles and Guides</h1>
        
        <p>
          Explore our collection of articles, tutorials, and guides to help you maximize your 
          productivity with Microsoft Teams and Delayed Send. Learn how to schedule messages effectively, 
          improve team communication, and implement best practices for remote 
          and hybrid work environments.
        </p>

        <div className="mt-8 space-y-8">
          {articles.map((article) => (
            <div key={article.slug} className="border-b pb-6">
              <h2 className="text-xl font-bold mb-2">
                <Link href={`/article/${article.slug}`}>
                  {article.title}
                </Link>
              </h2>
              <p className="text-gray-600 dark:text-gray-300">{article.description}</p>
              <Link href={`/article/${article.slug}`} className="mt-2 inline-block text-blue-600 dark:text-blue-400 hover:underline">
                Read the full article →
              </Link>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default ArticlesIndex

export const getServerSideProps: GetServerSideProps<SSP> = async (context) => {
  return {
    props: {
      insideTeams: !!context.query.teamsEmail,
    },
  }
}